import axiosApi from "../axiosInstance";

async function getWorkFlowCategoryList(request) {
    try {
        const response = await axiosApi.get(`/WorkFlowCategory/GetAllWorkFlowCategory`, request);
        return response?.data;
    } catch (error) {
        console.log("Error getWorkFlowCategoryList===>:", error);
        return error?.response?.data;
    }
};


async function createUpdateWorkFlowCategory(request) {
    try {
        const response = await axiosApi.post(`/WorkFlowCategory/CreateUpdateWorkFlowCategory`, request);
        return response?.data;
    } catch (error) {
        console.log("Error createUpdateWorkFlowCategory===>:", error);
        return error?.response?.data;
    }
};


export const WorkFlowCategoryService = {
    getWorkFlowCategoryList,
    createUpdateWorkFlowCategory,
}